module.exports = __webpack_public_path__ + "static/media/piper-dialog1-desktop-es.4fa2107a.svg";